export default __webpack_public_path__ + "static/media/peru.e674c54d.svg";